import { render } from "./EventList.vue?vue&type=template&id=7a2cd89e"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"
script.render = render

export default script